import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfa2',
  templateUrl: './mfa2.component.html',
  styleUrls: ['./mfa2.component.scss']
})
export class Mfa2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
